import React from "react";

function header() {
  return (
    <div id="header"><h1>&lt;Web Design By: Bryan Dalton /&gt; </h1>
    </div>
  );
}

export default header;
